import { Entity } from './../select-list/select-list.component';
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { MyUtility } from '../../comparison';
import { ValueSet } from '../../value-set';
import { AlertService } from '../../alert.service';

@Component({
  selector: 'app-parametrics',
  templateUrl: './parametrics.component.html',
  styleUrls: ['./parametrics.component.css']
})
export class ParametricsComponent implements OnInit {
  currentFilter: any = {};
  showSecondRow = false;
  allDrugs;
  drugFamilies;

  Drug;
  Any;
  All;
  public title : string;
  constructor(public api: ApiService, private alerter: AlertService) {
   }

  ngOnInit() {
    if (this.selectedZoneId == null)
      this.selectedZoneId = 0;
    if (this.selectedOperatorId == null)
      this.selectedOperatorId = 0;

    this.showOrHideSecondRow();

    this.allDrugs = this.api.session.drugs.find(x => x.name === "All").children;
    this.drugFamilies = this.api.session.drugs.filter( x => x.id !== null);

    this.Drug = new ValueSet(this.allDrugs, "id");
    this.Drug = new ValueSet(this.allDrugs, "id");
    this.Drug.prefixText = "the drug ";
    this.Any = new ValueSet(this.drugFamilies, "id");
    this.Any.prefixText = "any of the drugs in class ";
    this.All = new ValueSet(this.drugFamilies, "id");
    this.All.prefixText = "all of the drugs in class ";
  }

  get zoneOptions() {
    return this.api.session.parametrics.zoneOptions;
  }

  get selectedZoneId() {
    return (this.currentFilter.selectedZone || {}).id;
  }
  set selectedZoneId(value) {
    this.currentFilter.selectedZone = this.zoneOptions.find(x => x.id == value);
    this.showOrHideSecondRow();
  }

  get operatorOptions() {
    return this.api.session.parametrics.operatorOptions;
  }

  get selectedOperatorId() {
    return (this.currentFilter.selectedOperator || {}).id;
  }
  set selectedOperatorId(value) {
    this.currentFilter.selectedOperator = this.operatorOptions.find(x => x.id == value);
  }

  showOrHideSecondRow(){
    let zone = this.currentFilter.selectedZone || {};
    
    this.showSecondRow = 
      zone.id === 1 ||
      zone.id === 2;
  }

  get selectedFilters(): any{
    return this.api.session.currentCriteria.parametricFilters;
  }

  getValidFilter(){
    
    // console.log(JSON.stringify(this.Drug));
    // console.log(JSON.stringify(this.Any));
    // console.log(JSON.stringify(this.All));

    let filter = this.currentFilter;
    if(!filter.selectedZone || !filter.drugFilterType)
      return null;

    let filterType = this[this.currentFilter.drugFilterType];
    if(!filterType)
      return null;
    filter.drugOrFamily = filterType.objectValue;
    if(!filter.drugOrFamily)
      return null;
    // console.log(JSON.stringify(filterType));
    // console.log(JSON.stringify(filter));

    filter.filterText = "The organism must " + filter.selectedZone.name + " ";
    if(this.showSecondRow){
      if(!filter.selectedOperator || !filter.operand || filter.selectedOperator.id == 0)
        return null;
      filter.filterText += filter.selectedOperator.name + " " + filter.operand + " for ";
    }
    filter.filterText += filterType.prefixText + filter.drugOrFamily.name;

    return filter;
  }

  addCurrentFilter(){
    let filter = this.getValidFilter();

    if(!filter){
      this.alerter.alert("Invalid selection");
      return;
    }

    this.selectedFilters.push(filter);

    console.log("filters", this.selectedFilters);

    this.clearInputs();
  }

  clearInputs(){
    this.currentFilter = {};
    this.Drug.selectedIdValue = null;
    this.Any.selectedIdValue = null;
    this.All.selectedIdValue = null;

    if (this.selectedZoneId == null)
      this.selectedZoneId = 0;
    if (this.selectedOperatorId == null)
      this.selectedOperatorId = 0;
      
    this.showOrHideSecondRow();
  }

  deleteFilterAtIndex(index){
    this.selectedFilters.splice(index,1);
  }

  clearCurrent(){
    this.api.session.currentCriteria.parametricFilters = [];
    this.clearInputs();
  }
}
